import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router-dom';
import { RootState } from 'modules';
import moment from 'moment';
import apiClient from 'libs/api/apiClient';
import { ERoute } from 'enums/route.enum';
import { device } from 'GlobalStyles';
import InterviewMasterClassBasicPageDesktopUI from './InterviewMasterClassBasicPageDesktopUI';
import InterviewMasterClassBasicPageMobileUI from './InterviewMasterClassBasicPageMobileUI';

function InterviewMasterClassBasicPage() {
  const history = useHistory();
  const isMobile = useMediaQuery({ query: device.md });
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [reviews, setReviews] = useState([]);
  const purchaseInfo = {
    isPurchased: !!currentUser?.is_interview_master_class_basic_available,
    endDatetime: moment(currentUser?.interview_master_class_basic_end_datetime).format('YYYY-MM-DD HH:mm'),
  };

  const handleClickCTA = () =>
    purchaseInfo.isPurchased
      ? history.push(ERoute.LectureInterviewMasterClassBasicVideoPlayer)
      : history.push('/purchase/interview-master-class-basic');

  useEffect(() => {
    apiClient.get('/lectures/1/reviews').then((res) => setReviews(res.data));
  }, []);

  return isMobile ? (
    <InterviewMasterClassBasicPageMobileUI
      onClickCTA={handleClickCTA}
      purchaseInfo={purchaseInfo}
      reviews={reviews}
    />
  ) : (
    <InterviewMasterClassBasicPageDesktopUI
      onClickCTA={handleClickCTA}
      purchaseInfo={purchaseInfo}
      reviews={reviews}
    />
  );
}

export default InterviewMasterClassBasicPage;
